import { FormValidator } from './vacancy-perza-validator';
import 'devbridge-autocomplete';

/**
 * Form class for the collapsing vacancy form
 * @Docs: https://www.npmjs.com/package/devbridge-autocomplete
 */
export class FormVacancy {
    constructor() {
        this.$form = $('#vacancy-order-form');
        if (this.$form.length === 0) {
            return;
        }
        this.$steps = this.$form.find('.form-collapse__step');
        this.$next = this.$form.find('.js-next');
        this.$btnPayment = this.$form.find('button[type="submit"]');
        this.$fieldEducation = $('#current_education');
        this.$fieldInstitute = $('#current_institute');

        this.validator = new FormValidator(this.$form);

        // bind events
        this.$next.on('click', () => this.onNext());
        this.$steps.first().find('.form-collapse__step-header').on('click', () => this.onPrevious());
        this.$form.on('keypress', e => e.which !== 13); // prevent form submit when enter is pressed

        // init autocomplete fields
        // TODO enable the autocomplete fields when the endpoints work
        //  issue https://gitlab.com/techniek-team/lyceo-wp-site/issues/214
        // if (this.$fieldEducation.length > 0) this.autoCompleteEducation();
        // if (this.$fieldInstitute.length > 0) this.autoCompleteInstitute();

        $('.js-mobile-phone').on('change', e => this.convertToInternationalFormat(e));
    }

    /**
     * Transform the leading 06 to +316
     * @param e
     */
    convertToInternationalFormat(e) {
        const value = $(e.currentTarget).val()
            .trim()
            .replace(/^06+/, '+316')
            .replace(/\s+/g, '');

        $(e.currentTarget).val(value);
    }

    /**
     * Allow the user to go back to the first step without validating the form
     */
    onPrevious() {
        const $isActive = this.$steps.first()
            .hasClass('form-collapse__step--active');
        if ($isActive === false) {
            this.goToFirst();
        }
    }

    /**
     * Go to the next step if the form is valid
     */
    onNext() {
        if (this.validator.check.form()) {
            this.goToNext();
        }
    }

    /**
     * Activate the first part of the form
     */
    goToFirst() {
        const $activeStep = this.$form.find('.form-collapse__step--active');
        const $nextStep = this.$steps.first();

        this.validator.hideErrors();

        $activeStep.find('.form-collapse__step-content').slideUp();
        $nextStep.find('.form-collapse__step-content').slideDown();

        $activeStep.removeClass('form-collapse__step--active');
        $nextStep.addClass('form-collapse__step--active');

        this.scrollTop();
    }

    /**
     * Activate the last step of the form
     */
    goToNext() {
        const $activeStep = this.$form.find('.form-collapse__step--active');
        const $nextStep = $activeStep.next('.form-collapse__step');

        this.validator.hideErrors();

        // validate adds the error class to empty fields in the next step
        $nextStep.find('.error').removeClass('error');

        $activeStep.find('.form-collapse__step-content').slideUp();
        $nextStep.find('.form-collapse__step-content').slideDown();

        $activeStep.removeClass('form-collapse__step--active');
        $nextStep.addClass('form-collapse__step--active');

        this.scrollTop();
    }

    /**
     * Scroll almost to the top of the page,
     * little offset of 140px from the top of the form
     */
    scrollTop() {
        $('html, body').animate({ scrollTop: this.$form.offset().top - 140 }, 300);
    }

    /**
     *  if the autocomplete functions are used somewhere else
     *  put them in separate component
     */
    autoCompleteInstitute() {
        const $fieldInstitute = $('#current_institute');
        $fieldInstitute.autocomplete({
            lookup: (request, response) => {
                $fieldInstitute.next('.js-autocomplete-spinner')
                    .html(' <i class="fa fa-circle-o-notch fa-spin bem-input-field__spinner-icon"></i>');
                this.getInstitutes($fieldInstitute.val(), response);
            },
            lookupLimit: 10,
            minChars: 3,
            zIndex: 1,
            deferRequestBy: 300,
            onSelect: (e, ui) => this.fillAutocompleteField($fieldInstitute, e, ui),
        });
    }

    /**
     * Get the autocompleted list from skoleo depending on the searchkey
     * @param searchKey
     * @param response
     * @returns {jQuery|*}
     */
    getInstitutes(searchKey, response) {
        return $.ajax({
            url: ajax_link,
            method: 'POST',
            data: {
                action: 'lyceo',
                controller: 'Institute',
                method: 'find',
                searchKey: searchKey,
                nonce: ajax_nonce,
            },
            dataType: 'json',
            success: (data) => this.handleAutocompleteResponse(data, response),
            always: () => $('.js-autocomplete-spinner .fa').remove(),
        });
    }

    /**
     * if the autocomplete functions are used somewhere else
     * put them in separate component/service
     */
    autoCompleteEducation() {
        const $fieldEducation = $('#current_education');
        $fieldEducation.autocomplete({
            lookup: (request, response) => {
                $fieldEducation.next('.js-autocomplete-spinner')
                    .html(' <i class="fa fa-circle-o-notch fa-spin bem-input-field__spinner-icon"></i>');
                this.getStudies($fieldEducation.val(), response);
            },
            lookupLimit: 10,
            minChars: 3,
            zIndex: 1,
            deferRequestBy: 300,
            onSelect: /* istanbul ignore next */ (e, ui) => this.fillAutocompleteField($fieldEducation, e, ui),
        });
    }

    /**
     * Get the autocompleted list from skoleo depending on the searchkey
     * @param searchKey
     * @param response
     * @returns {jQuery|*}
     */
    getStudies(searchKey, response) {
        return $.ajax({
            url: ajax_link,
            method: 'POST',
            data: {
                action: 'lyceo',
                controller: 'Education',
                method: 'find',
                searchKey: searchKey,
                nonce: ajax_nonce,
            },
            dataType: 'json',
            success: (data) => this.handleAutocompleteResponse(data, response),
            always: () => $('.js-autocomplete-spinner .fa').remove(),
        });
    }

    handleAutocompleteResponse(data, response) {
        $('.js-autocomplete-spinner .fa').remove();
        const results = { suggestions: [] };
        for (let id in data.items) {
            results.suggestions.push({
                value: data.items[id],
                data: id,
            });
        }
        results.suggestions
            .sort((a, b) => a.value.localeCompare(b.value));
        response(results);
    }

    /**
     * Fills the fields with the result of selected option from the
     * autocomplete dropdown
     * Stores the id in a hidden field
     * @param $field
     * @param e
     * @param ui
     */
    fillAutocompleteField($field, ui) {
        $field.val(ui.value);
        $field.prev('input').val(ui.data);
    }
}
